<template>
    <div class="page container">
        <h1 class="is-size-3"><small class="has-text-weight-bold">Usuários</small> </h1>
        <br />
			<hr />
			<el-table
		    :data="usuarios"
		    stripe
		    style="width: 100%">
		    <el-table-column
		      prop="nome"
		      label="Nome">
		    </el-table-column>
		    <el-table-column
		      prop="email"
		      label="E-mail"
		      width="250"
		      >
	      </el-table-column>
	      <el-table-column
	      prop="celular"
	      label="Telefone"
	      width="250"
	      >
		      
		    </el-table-column>

		    <el-table-column
	      prop="estado"
	      label="Estado"
	      width="250"
	      >
		      
		    </el-table-column>

		   
		    <el-table-column
		      label=""
		      width="50">
		      <template slot-scope="scope">
	          <el-button-group>
		        	<!--<el-button type="primary" size="small" @click='openCurso(scope.row)'><i class="fas fa-sign-in-alt" ></i></el-button>
		          <el-button type="danger" size="small" ><i class="fas fa-trash"></i></el-button>-->
		        </el-button-group>
		      </template>
		    </el-table-column>
		  </el-table>
    </div>
</template>


<script>
import moment from 'moment'
import utils from '@/utils'
import { mapState } from 'vuex'
import Store from '@/store'
import axios from 'axios'


export default {
		watch: {
	    '$route.params': function (params) {
	      this.load(params);
	    }
	  },
	  computed:{
		  ...mapState({
	      disciplinas: state => state.session.disciplinas
	      
	    }),
		},
	  data(){
	  	return {
	  		activeIndex2: '1',
        usuarios: [
        ]
      }
	  },
		methods:{
			openCurso(row){
				this.$router.push(`/curso/${row.id}/conteudos`)
			},
			openNovoDominio(row){
				this.$router.push(`/admin/curso/novo`)
			},
			formatConteudo(conteudos){
				
				const maped = conteudos.map(c=>c.descricao);
				const joined = maped.join(",")
				if(joined == "")
					return "SEM DESCRIÇÃO"
				else
					return joined	
				
			},
			formatAtualizacao(atualizacao){
				return moment(atualizacao).fromNow();
			},
			formatData(data){
				if(data)
					return moment(data).format('DD | MMM')
				else
					return " - "
			},
			parseProva(p){
				const media1 = p.notas.reduce((acc,n)=>{
					const nota = parseFloat(n.nota);
					if(!isNaN(nota)){
						return nota + acc;
					}else{
						return acc;
					}
				},0)
				const numNotas = p.notas.length;
				let media = '-'
				if(numNotas>0){
					media = (media1/numNotas).toFixed(2)
				}
				return {...p, media: media}
			},
			load(params){
				this.course = params.course;
				this.turma = params.turma;
				Store.dispatch('teacher/getAulas', {
        	course: this.course, 
        	turma: this.turma
      	}).then(r=>{
      		this.aulas = r
      	},()=>{} );
      	Store.dispatch('teacher/getProvas', {
        	course: this.course, 
					turma: this.turma
				}).then(r=>{
					this.provas = r.map(this.parseProva);
				},()=>{} );
			},
			handleSelect(key, keyPath) {
				if(keyPath[0] == 'turma'){
					this.turmaLabel = key;
				}else{
					this.turma = key;
				}
				
      },
      getUsuarios(){
      	global.Loading.begin('Carregando Usuarios');
      	axios.get(`${global.base}/api/admin/usuarios`,{
          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
          }).then((r)=>{
          	
            this.usuarios = r.data.map((c) => {
            	return {...c, visivel: c.visivel == 1 ? true : false}
            });
            setTimeout(global.Loading.end, 1500 )
              
          }).catch(()=>{
            global.Loading.end();
          })
      }
		},
    mounted(){
			const params = this.$router.currentRoute.params;
			this.getUsuarios();
    }
};
</script>

<style scoped>

</style>
